import ProjectSubmissionForm from "../Seekar_form";

const PostSeekarform = () => {
  return (
    <>
      <ProjectSubmissionForm title="Submit Your Project for Listing" buttontitle="Submit for Review" />
    </>
  );
};

export default PostSeekarform;
